// main.js
import { createApp, h } from 'vue';
import App from './App.vue';
import Login from './components/Login.vue';
import './assets/styles/fonts.css';

const app = createApp({
  data() {
    return {
      isAuthenticated: false
    };
  },
  created() {
    const user = localStorage.getItem('user');
    const expiration = localStorage.getItem('expiration');
    const now = new Date().getTime();

    if (user && expiration && now < parseInt(expiration)) {
      this.isAuthenticated = true;
    }
  },
  render() {
    return this.isAuthenticated ? h(App) : h(Login, { onLoginSuccess: this.handleLogin });
  },
  methods: {
    handleLogin(user) {
      const expirationTime = new Date().getTime() + 60 * 60 * 1000; // 60 minutos
      localStorage.setItem('user', user);
      localStorage.setItem('expiration', expirationTime);
      this.isAuthenticated = true;
    }
  }
});

app.mount('#app');
